/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Card, TextContainer, Heading, ButtonGroup, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import withBlockCanDismiss from './blockCanDismiss';
import German from 'src/assets/images/dashboard/german.png';
import { URL } from 'src/constants/links';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  renderPopover: () => void
};

type ComposedProps = Props & WithI18nProps;

class NewLanguageNotification extends Component<ComposedProps> {
  render() {
    const { renderPopover, i18n } = this.props;

    return (
      <Card>
        <div className="BC-Block-Dismiss--Right-Menu">{renderPopover()}</div>
        <div>
          <div className="BC-NewLanguageNotification__Dashboard">
            <div className="BC-NewLanguageNotification__Wrapper">
              <div className="BC-NewLanguageNotification__Content">
                <Heading>
                  {i18n.translate('AdminHTML.Dashboard.NewLanguageNotification.title')}
                </Heading>
                <TextContainer>
                  <p>
                    {i18n.translate('AdminHTML.Dashboard.NewLanguageNotification.content', {
                      nt_break: <br />
                    })}
                  </p>
                  <ButtonGroup>
                    <Button
                      size="slim"
                      primary
                      onClick={() => {
                        this.openLink('NewLanguageNotification');
                      }}>
                      {i18n.translate(
                        'AdminHTML.Dashboard.NewLanguageNotification.button_ReadMore'
                      )}
                    </Button>
                    <Button plain onClick={() => {
                      history.push(routes.languageSetting.view())
                    }}>
                      {i18n.translate(
                        'AdminHTML.Dashboard.NewLanguageNotification.button_ChangeLanguage'
                      )}
                    </Button>
                  </ButtonGroup>
                </TextContainer>
              </div>
              <div className="BC-NewLanguageNotification__Image">
                <img
                  className="BC-Illustration-Image__Dashboard"
                  src={German}
                  alt={i18n.translate('AdminHTML.Dashboard.NewLanguageNotification.title')}
                />
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
  }

  openLink = (id: string) => {
    const newUrl = URL[id];
    window.open(newUrl, '_blank');
  };
}

export default withBlockCanDismiss(withI18n()(NewLanguageNotification));
